import React from 'react';
import './Forms.scss';
import FormsIcon from '../../assets/FormsIcon.png';
import McqIcon from '../../assets/McqIcon.png';
import ResumeIcon from '../../assets/ResumeIcon.png';

export default function Forms() {
  return (
    <div className='forms-container'>
      <div className='forms-heading-container'>
        <h1>Create and Customize with Ease – Forms, Question</h1>
        <h1>Papers & Resumes!</h1>
      </div>
      <div className='forms-mobile-heading-container'>
        <h1>Create and Customize with Ease</h1>
      </div>
      <div className='feature-section'>
        <div className='pdf-forms-container'>
          <div className='forms-icon-container'>
            <img src={FormsIcon} alt="forms" />
          </div>
          <div className='feature-info'>
            <h2>Create and Share Pdf Forms</h2>
            <p>
              Create and share custom PDF forms effortlessly—perfect for business, surveys, and more!
            </p>
          </div>
        </div>
        <div className='mcq-container'>
          <div className='mcq-icon-container'>
          <img src={McqIcon} alt="mcq" />
          </div>
          <div className='feature-info'>
            <h2>Create MCQ Question Paper</h2>
            <p>
              Easily create, customize, and share MCQ question papers in just a few clicks!
            </p>
          </div>
        </div>
        <div className='resume-container'>
          <div className='resume-icon-container'>
            <img src={ResumeIcon} alt="resume" />
          </div>
          <div className='feature-info'>
            <h2>Create and Share Your Resume</h2>
            <p>
              Build, customize, and share your professional resume effortlessly!
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
